module.exports = __webpack_public_path__ + "static/media/yeezy350v2.2e5d2176.jpg";